<template>
  <div>
    <pdf
      v-for="i in pageCount"
      class="pdf"
      :key="pdfComponentKey + i"
      :src="pdfLoadingTask"
      :page="i"
      :style="styleWithHeight"
      @page-loaded="handlePageLoaded"
      @loaded="onLoaded"
      @error="onPdfError"
    />
  </div>
</template>

<script>
import pdf from 'vue-pdf';
import { MYSTAGE_BASE_URL } from '@/utils/constants';

export default {
  components: { pdf },
  props: {
    pdfUrl: { type: String, required: true },
    styleWithHeight: { type: Object }
  },
  data() {
    return {
      pdfLoadingTask: null,
      pdfDocument: null,
      pdfLoaded: 0,
      pageCount: 0,
      retryCount: 0,
      pdfComponentKey: 0 // use to rerender component
    };
  },
  async mounted() {
    // Small delay to allow vue-pdf to fully clean up the canvas
    await new Promise((resolve) => setTimeout(resolve, 200));

    await this.createPdfTask();
  },
  watch: {
    async pdfUrl() {
      this.createPdfTask();
    }
  },
  methods: {
    async createPdfTask() {
      this.pdfLoadingTask = pdf.createLoadingTask({
        url: this.pdfUrl,
        cMapUrl: `${MYSTAGE_BASE_URL}cmaps/`,
        cMapPacked: true
      });

      try {
        this.pdfDocument = await this.pdfLoadingTask.promise;
        this.pageCount = this.pdfDocument.numPages || 1; // use pageCount internally
      } catch (err) {
        console.error('PDF load error:', err);
      }
    },
    async destroyPdfTask() {
      try {
        if (this.pdfLoadingTask) await this.pdfLoadingTask.destroy();
      } catch (e) {
        // ignore errors from already destroyed task
      } finally {
        this.pdfLoadingTask = null;
        this.pdfDocument = null;
      }
    },
    handlePageLoaded(event) {
      this.$emit('page-loaded', event);
    },
    onLoaded() {
      this.$emit('on-loaded', true);
    },
    async onPdfError(err) {
      if (this.retryCount >= 1) {
        this.$logger.debug('Loading PDF error after retry: ' + err.message);
        return;
      }

      const ignoreErrors = ['loadingTask', 'Invalid page request'];
      if (ignoreErrors.some((substr) => err?.message.includes(substr))) {
        return;
      }

      this.retryCount++;

      await new Promise((resolve) => setTimeout(resolve, 500));

      this.$logger.warn(`Retrying PDF load (${this.retryCount}) due to error: ${err.message}`);

      // Rerender pdf component
      this.pdfComponentKey++;
    }
  },
  beforeDestroy() {
    this.destroyPdfTask();
  }
};
</script>
